"use strict";
import EventEmitter2 from 'eventemitter2';

export default new EventEmitter2( {
    wildcard: true,
    delimiter: '.'
});